import { CommandRequestType } from "../../authentication/connection/commandRequestType";
import { ICommandParameters } from "../../authentication/connection/iCommandParameters";
import { ICommandResponse } from "../../authentication/connection/iCommandResponse";
import { CarrierResponseDto, ErrorDetails } from "../../authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "../../authentication/connection/iRequestCommand";


export class GetCarrierInfoByUserCommand extends IRequestCommand<
  IGetCarrierInfoResponse,
  ErrorDetails,
  IGetCarrierInfoCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'carriers/byUser/{userId}';
  public override setParameters(parameters: IGetCarrierInfoCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{userId}',
      parameters.carrierUserId
    );
  }
}

export interface IGetCarrierInfoCommandParameters extends ICommandParameters {
  carrierUserId: string;
}

export interface IGetCarrierInfoResponse
  extends CarrierResponseDto,
    ICommandResponse {}
